import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17 7h-.76a1 1 0 0 1-.7-1.71l.53-.53a1.01 1.01 0 0 0 0-1.42l-1.41-1.41a1.01 1.01 0 0 0-1.42 0l-.51.51a.97.97 0 0 1-.73.32 1 1 0 0 1-1-1V1a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v.76a1 1 0 0 1-1 1 .97.97 0 0 1-.73-.32l-.51-.51a1.01 1.01 0 0 0-1.42 0L1.93 3.34a1.01 1.01 0 0 0 0 1.42c.19.19.4.37.58.57a.92.92 0 0 1 .25.67 1 1 0 0 1-1 1H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.76a1 1 0 0 1 1 1 .92.92 0 0 1-.25.67c-.18.2-.39.38-.58.57a1.01 1.01 0 0 0 0 1.42l1.41 1.41a1.01 1.01 0 0 0 1.42 0l.51-.51a.97.97 0 0 1 .73-.32 1 1 0 0 1 1 1V17a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.76a1 1 0 0 1 1-1 .97.97 0 0 1 .73.32l.51.51a1.01 1.01 0 0 0 1.42 0l1.41-1.41a1.01 1.01 0 0 0 0-1.42l-.53-.53a1 1 0 0 1 .7-1.71H17a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m-8 5a3 3 0 1 1 3-3 3 3 0 0 1-3 3" }, null, -1)
  ]))]))
}
export default { render: render }